import { transient } from "aurelia-framework";
import { BaseRuleConfigPlugin } from "./base-rule-config-plugin";

@transient()
export class RequireGhgVerificationReview extends BaseRuleConfigPlugin {

    public itemSource: { name: string, value: boolean }[] =
        [
            { name: 'Any', value: undefined },
            { name: 'Verified', value: true },
            { name: 'Unverified', value: false }
        ];

}